import { IonRange } from '@ionic/react';
import { Color } from '../common/index.ts';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
    range: {
        paddingTop: 8,
        marginLeft: 15,
        marginRight: 15,
        '--bar-background': 'var(--ion-color-step-100)',
        '--bar-height': '40px',
        '--bar-border-radius': '16px',
        '--knob-size': '36px',
        '&::part(bar)': {
            left: 2 // workaround to hide first tick
        },
        '&::part(bar-active)': {
            height: 40,
            marginLeft: 2, // workaround for ioninc bug (active bar shows when value 0)
            borderRadius: 16 // workaround for ionic bug (should inerhit from --bar-border-radius)
        },
        '&::part(pin)': {
            fontSize: 11,
            top: 21,
            transform: 'scale(1.01)',
            zIndex: '3!important'
        },
        '&::part(tick)': {
            background: 'rgba(var(--ion-color-primary-rgb), 0.6)',
            width: 2,
            zIndex: 1
        },
        '&::part(tick-active)': {
            background: 'rgba(var(--ion-color-light-rgb), 0.6)',
            width: 2,
            zIndex: 1
        }
    }
});

export interface FatSliderProps {
    min: number;
    max: number;
    step?: number;
    color?: Color;
    value: number;
    onChange: (value: number) => void;
    labelFormatter?: (v: number) => string;
}

export const FatSlider: React.FC<FatSliderProps> = ({ min, max, step = 1, color = 'primary', value, onChange, labelFormatter }) => {
    const classes = useStyles();
    const style = {
        '--bar-background-active': `var(--ion-color-${color})`
    };

    labelFormatter = labelFormatter || (v => String(v));

    const handleChange = (e: any) => {
        onChange(e.detail.value);
    };

    return (
        <IonRange
            style={style}
            className={classes.range}
            min={min}
            max={max}
            step={step}
            snaps={true}
            ticks={step/max >= 0.05}
            value={value}
            pin={true}
            pinFormatter={labelFormatter}
            onIonInput={handleChange}
            debounce={20}
            mode="ios" // otherwise doesn't render correctly on web
            data-type="fat-slider"
        >
            {/* cover up last tick */}
            <div slot="end" style={{visibility: (value === max ? 'hidden' : 'visible'), zIndex: 1, position: 'relative', marginRight: -16}}>
                <div style={{position: 'absolute', background: 'var(--ion-color-step-100)', top: -4, right: 16, width: 2, height: 8}} />
            </div>
        </IonRange>
    );
};
